import { render, staticRenderFns } from "./AddressBuyView.vue?vue&type=template&id=7cddb9b4"
import script from "./AddressBuyView.vue?vue&type=script&lang=js"
export * from "./AddressBuyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports